<div class="container font-title">
    <div class="main-body">
          <div class="row gutters-sm">
            <div class="col-md-4 mb-3">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex flex-column align-items-center text-center">
                    <div [innerHTML]="safeAvatarSVG" class="profile-image"></div>
                    <!-- <img src="https://bootdey.com/img/Content/avatar/avatar7.png" alt="Admin" class="rounded-circle" width="150"> -->
                  </div>
                </div>
              </div>
              <div *ngIf="showConnectedTeacher" class="card mt-3">
                <div class="mt-3 d-flex flex-column align-items-center text-center">
                  <h4>Connected Teacher</h4>
                  <p class="text-secondary mb-1">Name: {{teacherInfo.name}}</p>
                </div>
              </div>
              <div class="card mt-3">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                    <button class="btn-hover color-1" id="avatar-creator-btn" (click)="goToAvatarCreationPage()" ><mat-icon svgIcon="superhero-icon">&nbsp;</mat-icon>Avatar Creator</button>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-8">
              <div class="card mb-3">
                <div class="card-body">
                  <div class="row">
                    <div class="col-sm-3">
                      <h6 class="mb-0">{{'profile.text3' | translate}}</h6>
                    </div>
                    <div class="col-sm-9 text-secondary">
                      {{userProfileInfo.name}}
                    </div>
                  </div>
                  <hr>
                  <div class="row">
                    <div class="col-sm-3">
                      <h6 class="mb-0">{{'profile.text10' | translate}}</h6>
                    </div>
                    <div class="col-sm-9 text-secondary">
                      {{userProfileInfo.username}}
                    </div>
                  </div>
                  <hr>
                  <div class="row">
                    <div class="col-sm-3">
                      <h6 class="mb-0">{{'profile.text4' | translate}}</h6>
                    </div>
                    <div class="col-sm-9 text-secondary">
                      {{userProfileInfo.email}}
                    </div>
                  </div>
                  <hr>
                  <div *ngIf="isChangePassword" class="row">
                    <form [formGroup]="changePwdForm" (ngSubmit)="onSubmitChangePwd(changePwdForm.value)">
                      <div class="col-sm-12">
                        <input class="form-control col-sm-12" type="password" [placeholder]="'profile.placeholder.text1' | translate" formControlName="oldPassword">
                        <span *ngIf="changePwd.oldPassword.touched && changePwd.oldPassword.errors?.required"
                        class="help-block alert-danger">{{ 'profile.text11' | translate }}</span>
                        <br>
                        <input class="form-control col-sm-12" type="password" [placeholder]="'profile.placeholder.text2' | translate" formControlName="newPassword">
                        <span *ngIf="changePwd.newPassword.touched && changePwd.newPassword.errors?.required"
                        class="help-block alert-danger">{{ 'profile.text11' | translate }}</span>
                        <br>
                        <input class="form-control col-sm12" type="password" [placeholder]="'profile.placeholder.text3' | translate" formControlName="cnfrmPassword">
                        <span *ngIf="changePwd.cnfrmPassword.touched && changePwd.cnfrmPassword.errors?.required"
                        class="help-block alert-danger">{{ 'profile.text11' | translate }}</span>
                        <span *ngIf="changePwd.cnfrmPassword.errors?.notMatching"
                        class="help-block alert-danger">{{ 'login.text13' | translate }}</span>
                        <br>
                        <input class="btn btn-success col-sm-12" type="submit" value="{{'profile.text12' | translate}}" [disabled]="changePwdForm.invalid">
                        <hr>
                      </div>
                    </form>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <a class="btn btn-info mr-1" (click)="changePassword()">{{'profile.text8' | translate}}</a>
                      <button class="btn btn-info" (click)="backToHome()">{{'profile.text9' | translate}}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
    </div>
